import type { ReactNode } from "react";
import { UserMenu } from "./UserMenu";
import { BrandLink } from "./ui/Brand";

/**
 * The one top bar every page uses: brand on the left, then any page-specific
 * links, then the user menu. 52px tall and sticky, so it costs as little of a
 * phone screen as possible while staying in reach.
 */
export function SiteHeader({
	children,
	width = "max-w-5xl",
}: {
	/** Extra controls placed before the user menu (e.g. a "Priser" link). */
	children?: ReactNode;
	/** Max width of the bar's content, to line up with the page below. */
	width?: string;
}) {
	return (
		<header className="sticky top-0 z-40 border-b border-line bg-canvas/85 backdrop-blur-md supports-[backdrop-filter]:bg-canvas/75">
			<nav
				className={`mx-auto flex h-13 items-center justify-between gap-2 px-4 sm:px-6 ${width}`}
				aria-label="Hovednavigasjon"
			>
				<BrandLink />
				<div className="flex items-center gap-1">
					{children}
					<UserMenu />
				</div>
			</nav>
		</header>
	);
}
